<div class="mcp-dialog-application">
  <div class="mcp-dialog-application__header">
    @for (item of headerImages; track item) {
      <img mcuiDefaultImage [class]="item.class" [srcUrl]="item.image" [title]="application.name" />
    }
  </div>
  <div class="mcp-dialog-application__body">
    @if (appWithOSIcon.includes($any(application.name))) {
      <img
        class="mcp-dialog-application__os"
        mcuiDefaultImage
        [srcUrl]="imageBasePath + 'logo--' + deviceOs + '.svg'"
        [title]="deviceOs"
      />
    }

    @if (!notInstallationAllowed) {
      @let downloadList = downloadList$ | async;

      <div class="mcp-dialog-application__actions">
        <div class="mcp-dialog-application__action">
          <div class="mcp-dialog-application__action-text">
            {{ 'MODAL_MCPRODUCTS_LABEL_OPEN' | translate: { applicationName: application.name } }}
          </div>

          <!--
            `url`, not `resourceUrl`: this is a deep link that is opened (navigated),
            not a resource that is loaded (iframe/embed/frame src). The `url` context
            passes custom schemes (e.g. `performancedesktop:`) while still neutralizing
            `javascript:`; `resourceUrl` would reject the custom scheme to null and
            leave the Open button inert.
          -->
          <a [href]="application.link | safe: 'url'" (click)="close()">
            <mcui-button text=" {{ 'MODAL_MCPRODUCTS_BTN_OPEN' | translate }}" />
          </a>
        </div>
        <div class="mcp-dialog-application__divider"></div>
        <div class="mcp-dialog-application__action">
          <div class="mcp-dialog-application__action-text mcp-dialog-application__text">
            {{
              'MODAL_MCPRODUCTS_LABEL_DOWNLOAD' | translate: { applicationName: application.name }
            }}
          </div>

          @for (item of downloadList; track item.url) {
            @if (item.os === deviceOs) {
              <a [href]="$any(item).url | safe: 'url'">
                <mcui-button text=" {{ 'MODAL_MCPRODUCTS_BTN_DOWNLOAD' | translate }}" />
              </a>
            }
          }
        </div>
      </div>
    } @else {
      <p class="mcp-dialog-application__text">
        {{ 'MTR_NOT_INSTALLATION_MESSAGE' | translate }}
      </p>
    }
  </div>
</div>
